module.exports = __webpack_public_path__ + "static/media/DistractionTechniquesGREEK.0884b4cc.vtt";